import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PwaInitialState {
  private _hasRenderedOnServer = false;

  setHasRenderedOnServer(hasRenderedOnServer: boolean) {
    this._hasRenderedOnServer = hasRenderedOnServer;
  }

  hasRenderedOnServer() {
    return this._hasRenderedOnServer;
  }
}
